<template>

<app-content :loading="is.loading">

	<app-content-head title="Overview" />

	<app-content-body class="overview" v-if="!is.loading">

		<com-days :days="data.days" />

	</app-content-body>

</app-content>

</template>

<script>

import comDays from './conventionvolunteersoverview/Days'

export default {

	components: {
		'com-days': comDays
	},

	data: function() {
		
		return {

			is: {
				loading: true
			},

			data: {}

		}

	},

	created: function() {
	
		this.load()
	
	},
	
	methods: {
	
		load: function() {
		
			this.$api.get('convention/volunteers/overview').then(function(json) {
			
				this.data = json.data

				this.is.loading = false
			
			}.bind(this))
		
		}
	
	}

}

</script>

<style scoped>

.summary-wrapper {
	display: grid;
	grid-template-columns: auto 200px;
	grid-gap: 10px;
}

</style>